import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBaseUrl } from "@utils/general/getBaseUrl";
import { GOODS_ISSUE_NOTE } from "@utils/constants/goods-request/goods-issue-note.contants";
import { baseQueryWithReauth } from "@states/auth/auth.api";

export const goodsIssueApi = createApi({
  reducerPath: "goodsIssueApi",
  tagTypes: ["GoodsIssue"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllGoodsIssue: builder.query<
      [],
      {
        page?: number;
        limit?: number;
        goods_issue_note_id?: string | number;
        // customer_first_name?: string;
        direct_sales_invoice_code?: string;
        direct_sales_return_code?: string;
        search?: string;
        from_date?: any;
        to_date?: any;
        status: string;
        reference_id?: string;
        reference_type?: string;
        business_unit_name?: string;
        customer_first_name?: string;
        business_unit_ids?: string;
        reference_ids?: string;
        customer_ids?: string;
      }
    >({
      query: ({
        page = 1,
        limit = 10,
        goods_issue_note_id,
        direct_sales_invoice_code,
        direct_sales_return_code,
        search,
        from_date,
        to_date,
        status,
        reference_id,
        reference_type,
        business_unit_name,
        customer_first_name,
        business_unit_ids,
        reference_ids,
        customer_ids,
      }) => {
        const queryParams = {
          url: GOODS_ISSUE_NOTE.GET_ALL,
          params: { page, limit },
        };
        if (search) {
          //@ts-ignore
          queryParams.params.search = search;
        }

        if (from_date) {
          //@ts-ignore
          queryParams.params.from_date = from_date
        }

        if (to_date) {
          //@ts-ignore
          queryParams.params.to_date = to_date;
        }

        if (status) {
          //@ts-ignore
          queryParams.params.status = status;
        }

        if (reference_id) {
          //@ts-ignore
          queryParams.params.reference_id = reference_id;
        }

        if (reference_type) {
          //@ts-ignore
          queryParams.params.reference_type = reference_type;
        }

        if (business_unit_name) {
          //@ts-ignore
          queryParams.params.business_unit_name = business_unit_name;
        }

        if (customer_first_name) {
          //@ts-ignore
          queryParams.params.customer_first_name = customer_first_name;
        }


        if (goods_issue_note_id) {
          //@ts-ignore
          queryParams.params.goods_issue_note_id = goods_issue_note_id;
        }


        if (business_unit_ids) {
          //@ts-ignore
          queryParams.params.business_unit_ids = business_unit_ids;
        }

        if (reference_ids) {
          //@ts-ignore
          queryParams.params.reference_ids = reference_ids;
        }

        if (customer_ids) {
          //@ts-ignore
          queryParams.params.customer_ids = customer_ids;
        }

        // if (direct_sales_invoice_code) {
        //     //@ts-ignore
        //     queryParams.params.direct_sales_invoice_code =
        //         direct_sales_invoice_code;
        // }

        // if (direct_sales_return_code) {
        //     //@ts-ignore
        //     queryParams.params.direct_sales_return_code =
        //         direct_sales_return_code;
        // }

        return queryParams;
      },
    }),

    getGoodsIssue: builder.query<any, { goods_issue_id: string | number }>({
      query: ({ goods_issue_id }) =>
        `${GOODS_ISSUE_NOTE.GET_ONE}${goods_issue_id}`,
    }),

    getStockGoodsIssue: builder.query<any, { goods_issue_id: string | number }>(
      {
        query: ({ goods_issue_id }) =>
          `${GOODS_ISSUE_NOTE.GET_ONE_STOCK}${goods_issue_id}`,
      }
    ),
    createGoodsIssue: builder.mutation({
      query: (body) => ({
        url: GOODS_ISSUE_NOTE.CREATE,
        method: "POST",
        body,
      }),
    }),
    updateGoodsIssue: builder.mutation({
      query: ({ id, body }) => ({
        url: `${GOODS_ISSUE_NOTE.UPDATE}${id}`,
        method: "PATCH",
        body,
      }),
    }),

    deleteGoodsIssue: builder.mutation({
      query: ({ id, body }) => ({
        url: `${GOODS_ISSUE_NOTE.DELETE}${id}`,
        method: "DELETE",
        body,
      }),
    }),

    GetGoodIssueNotePrint: builder.query<any, { id: string | number }>({
      query: ({ id }) => {
        return `${GOODS_ISSUE_NOTE.GET_ONE_FOR_PRINT}${id}`;
      },
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllGoodsIssueQuery,
  useGetGoodsIssueQuery,
  useGetStockGoodsIssueQuery,
  useLazyGetGoodsIssueQuery,
  useLazyGetStockGoodsIssueQuery,
  useCreateGoodsIssueMutation,
  useUpdateGoodsIssueMutation,
  useDeleteGoodsIssueMutation,
  useGetGoodIssueNotePrintQuery,
} = goodsIssueApi;
